// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum BoundaryType {
  Before = 0,
  After = 1,
  StartOfDoc = 2,
  EndOfDoc = 3
}
